import { Result, Spin } from 'antd';

const PaymentScreenFreezLoader = ({ loading, text = "Loading..." }) => {
    if (!loading) return null;

    return (
        <div className={'screenfreezloader'}>
            <Spin size="large" tip={text} />
            <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Result
                    // icon={<Spin size="large" />}
                    title="Redirecting to Payment Gateway"
                    subTitle="Please wait while we redirect you to Cashfree Checkout..."
                />
            </div>
        </div>
    );
};

export default PaymentScreenFreezLoader;
